import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getHomeRouteForRole } from "@/constants/routes";
import { useAuth } from "@/shared/hooks/useAuth";

const AuthenticatedRoute = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, isHydrated, user } = useAuth();
  const location = useLocation();

  if (!isHydrated) {
    return <div style={{ padding: 24 }}>Loading session...</div>;
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={getHomeRouteForRole(user?.role)}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default AuthenticatedRoute;
